import request from '@/utils/request'
//get
export function getAuthByProduct(){
  return request({
    url: `/c9auth/`,
    method:'GET'
  })
}
export function getAuthBySearch(params){
  return request({
    url: `/c9auth/${params}`,
    method:'GET'
  })
}

export function verifyCode(data){
  return request({
    url: '/c9auth/verify_code/',
    method:'POST',
    data
  })
}
export function getCertificateById(id){
  return request({
    url: `/c9auth/${id}/certificate/`,
    method:'GET',
  })
}

export function addTrail(data){
  return request({
    url: '/c9auth/trail/',
    method:'POST',
    data
  })
}

export function buyPrice(data){
  return request({
    url: `/c9auth/buy_price/`,
    method:'POST',
    data
  })
}

export function buy(data){
  return request({
    url: `/c9auth/buy/`,
    method:'POST',
    data
  })
}

//update
export function updateAuth(id, data){
  return request({
    url: `/c9auth/${id}/`,
    method:'PATCH',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/c9auth.js